import type { FaireProductEntity } from "../../entity_types/product";

export const p_384mz79hu4: FaireProductEntity = {
  token: "p_384mz79hu4",
  type: "product",
  name: "Pastel Cotton Jersey Infant Mittens",
  brandToken: "b_2mjydukmqy",
  brandName: "Bambini Infant Wear inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/979f9029a1af081f4e0d38a780c3edfcd1fb496c70b84c99059854bac35ca5e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc54d855880ec7934a80ee25a1b27b135e6c72b04f1f2fc68ea77ad7e8236be8.jpeg",
    "https://cdn.faire.com/fastly/6092ee80eb317a42a096fca5228c951b7e15662eede43919d509fa3f921aa3a4.jpeg",
    "https://cdn.faire.com/fastly/20e54cb42796f115e401c126fd946e9d0542a3906746459a7b77b8501711391d.jpeg",
    "https://cdn.faire.com/fastly/4d17336e42a95f9b9e2eeef41dd8333437b866fde3261bcc887b7f5126c72161.jpeg",
  ],
  priceDollars: 0.98,
  description:
    "Keep your little one toasty warm and scratch-free with caps and no scratch mittens bundle.  Each piece is made with soft comfortable cotton.  The no-scratch mittens may be worn anytime day or night to prevent scratching.\n\nAssorted Pastels Cotton Jersey Infant Mittens\n\nInfant Mittens made from 100% Cotton Jersey\n\nColors: Blue, Pink, Yellow, White\n\nOne Size Only\n\n1 Per Pack",
  tags: [],
  msrpDollars: 2.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:47.605Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
